"use client";

import RouteError from "@/components/RouteError";

export default function Error(props) {
  return (
    <RouteError
      {...props}
      title="Butikker kunne ikke lastes"
      description="Prøv igjen for å hente butikkdataene på nytt."
    />
  );
}
